import script from "./InvestForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestForm.vue?vue&type=script&setup=true&lang=ts"

export default script